import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-later-date": ""
}
const _hoisted_2 = {
  key: 0,
  class: "m-0 text-sm text-gray-600"
}

import { computed, ref } from 'vue'

import InlineDatePicker from '@/components/neue/InlineDatePicker.vue'
import DateGrid from '@/components/neue/wizard/DateGrid.vue'
import SelectionCard from '@/components/neue/wizard/SelectionCard.vue'
import SelectionGroup from '@/components/neue/wizard/SelectionGroup.vue'
import WeekdayPicker from '@/components/neue/wizard/WeekdayPicker.vue'
import WizardSection from '@/components/neue/wizard/WizardSection.vue'
import { injectWizard } from '@/composables/useWizardContext'
import {
  LATER_DATE_LABELS,
  ONCE_DATE_DAYS,
  ONE_DAY_NOTE,
  RECOMMENDED_RHYTHM,
  rhythmAllowsManyDays,
  RHYTHMS,
  sectionCopy,
  WEEKDAYS
} from '@/config/fulfillmentWizardSteps'
import { dateObjectToServerDay, serverDayToDateObject } from '@/helpers/dates'


export default {
  __name: 'StepDays',
  setup(__props) {

const wizard = injectWizard()

const once = computed(() => wizard.data.schedule.rhythm === 'once')
const many = computed(() => rhythmAllowsManyDays(wizard.data.schedule.rhythm))

const lastGridDay = () => {
  const day = new Date()
  day.setDate(day.getDate() + ONCE_DATE_DAYS - 1)
  return dateObjectToServerDay(day)
}
const laterOpen = ref(!!wizard.data.schedule.date && wizard.data.schedule.date > lastGridDay())
const pickedDate = computed({
  get: () => (wizard.data.schedule.date ? serverDayToDateObject(wizard.data.schedule.date) : null),
  set: value => (wizard.data.schedule.date = value ? dateObjectToServerDay(value) : null)
})

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WizardSection, _mergeProps(_unref(sectionCopy)('rhythm', _unref(wizard).data), { plain: "" }), {
      default: _withCtx(() => [
        _createVNode(SelectionGroup, { label: "How often" }, {
          default: _withCtx(({ groupName }) => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(RHYTHMS), (rhythm) => {
              return (_openBlock(), _createBlock(SelectionCard, {
                key: rhythm.value,
                name: groupName,
                icon: "repeat",
                title: rhythm.title,
                subtitle: rhythm.subtitle,
                chip: rhythm.value === _unref(RECOMMENDED_RHYTHM) ? 'Recommended' : '',
                selected: _unref(wizard).data.schedule.rhythm === rhythm.value,
                onSelect: $event => (_unref(wizard).setRhythm(rhythm.value))
              }, null, 8, ["name", "title", "subtitle", "chip", "selected", "onSelect"]))
            }), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 16),
    (once.value)
      ? (_openBlock(), _createBlock(WizardSection, _normalizeProps(_mergeProps({ key: 0 }, _unref(sectionCopy)('date', _unref(wizard).data))), {
          default: _withCtx(() => [
            (laterOpen.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(InlineDatePicker, {
                    modelValue: pickedDate.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((pickedDate).value = $event)),
                    mode: "date",
                    "min-date": new Date()
                  }, null, 8, ["modelValue", "min-date"])
                ]))
              : (_openBlock(), _createBlock(DateGrid, {
                  key: 1,
                  modelValue: _unref(wizard).data.schedule.date,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_unref(wizard).data.schedule.date) = $event)),
                  days: _unref(ONCE_DATE_DAYS),
                  "start-offset": 0,
                  tz: _unref(wizard).timeZone.value
                }, null, 8, ["modelValue", "days", "tz"])),
            _createElementVNode("button", {
              type: "button",
              "data-later-toggle": "",
              class: "self-start text-sm text-gray-600 underline hover:text-gray-900",
              onClick: _cache[2] || (_cache[2] = $event => (laterOpen.value = !laterOpen.value))
            }, _toDisplayString(laterOpen.value ? _unref(LATER_DATE_LABELS).close : _unref(LATER_DATE_LABELS).open), 1)
          ]),
          _: 1
        }, 16))
      : (_openBlock(), _createBlock(WizardSection, _normalizeProps(_mergeProps({ key: 1 }, _unref(sectionCopy)('days', _unref(wizard).data))), {
          default: _withCtx(() => [
            _createVNode(WeekdayPicker, {
              "model-value": _unref(wizard).data.schedule.weekdays,
              days: _unref(WEEKDAYS),
              label: "Days",
              "onUpdate:modelValue": _unref(wizard).setWeekdays
            }, null, 8, ["model-value", "days", "onUpdate:modelValue"]),
            (!many.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(ONE_DAY_NOTE)), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 16))
  ], 64))
}
}

}